module.exports = __webpack_public_path__ + "img/公安logo.58f55c5c.png";